/*
 * Alternative Products - in-stock alternatives for PDP pages
 *
 **/
require('custom/type-design-id');
require('custom/gtm-handler'); // Google Tag Manager Handler
require('custom/product-card-pillow');
import { EXCLUDE_FILTER, USER_UNAUTH_COLLAB, DEFAULT_ATTR_TO_RETRIEVE, MANUAL_HIDE_COLLAB } from '../common/constant';

custom.alternativeProducts = (function() {

  const search = (item={}, size="", options={}) => {

    // Presets
    const defaults = {
      id: algoliaShopify.config.app_id, // Account ID
      key: algoliaShopify.config.search_api_key, // Account Key
      searchIndex: window.AlgoliaIndices.products, // InstantSearch Index
      searchLimit: 4, // Hits per page
      instantSearchFilter: '', // Type to filter (ie. Rugs, Latest, etc)
      resultsWrapperClass: "js-alternative-products",
      resultsContainerID: 'alternative-products-container', // Results ID
      attributesToRetrieve: null,
      cardRenderedCallback: null, // Do something with UI after rendering
      resultsLoadedCallback: null, // Do something after payload is added to DOM
    };

    // Merge args
    const opts = Object.assign({},defaults,options);

    // Test for Algolia Account ID (required)
    try {
        if(!opts.id) {
            throw 'Please provide an Algolia Account ID (options.id)';
        }
    } catch(e) {
        console.log('error: ', e);
        return;
    }

    // Test for Algolia Account Key (required)
    try {
        if(!opts.key) {
            throw 'Please provide an Algolia Account Key (options.key)';
        }
    } catch(e) {
        console.log('error: ', e);
        return;
    }

    // Test for instantSearchIndex (required)
    try {
        if(!opts.searchIndex) {
            throw 'Please provide an Algolia Search Index (options.instantSearchIndex)';
        }
    } catch(e) {
        console.log('error: ', e);
        return;
    }

    // Attributes needed to render
    if (!opts.attributesToRetrieve) opts.attributesToRetrieve = DEFAULT_ATTR_TO_RETRIEVE;

    // ---------- Filter & Filter Facets Query
    let filters = `${EXCLUDE_FILTER} AND NOT handle:${item.handle} AND inventory_quantity > 0 AND product_type:${item.product_type}`;
    if (item.collection && item.collection != "") filters += ` AND NOT named_tags.Collection:'${item.collection}'`;
    let facetFilters = [];
    let optionalFilters = [];
    let numericFilters = [];

    // 01. Price - Price Range
    if (item.price && item.price != "") {
      // Use Variant Universal Price (meta.loloi.price) to filter
      if (item.product_type != "THROWS") numericFilters.push(`meta.loloi.price>=${custom.utils.getPriceRange(item.price).split(":")[0]}`, `meta.loloi.price<=${custom.utils.getPriceRange(item.price).split(":")[1]}`);
    }
    // 02. Color
    if (item.color && item.color != "") {
      facetFilters.push(`named_tags.Color:${item.color}<score=4>`);
    }
    // 03. Style
    if (item.style && item.style != "") {
      facetFilters.push(`named_tags.Style:${item.style}<score=1>`);
    }
    // 04. Material
    if (item.material && item.material != "") {
      if (item.product_type != "THROWS") facetFilters.push(`named_tags.Material:${item.material}<score=1>`);
    }
    // 05. Construction
    if (item.construction && item.construction != "") {
      if (item.product_type != "THROWS") facetFilters.push(`named_tags.Construction:${item.construction}<score=1>`);
    }
    // 06. Collaboration
    if (item.collaboration && item.collaboration != "") {
      if (item.product_type != "THROWS") optionalFilters.push(`named_tags.Collaboration:${item.collaboration}<score=1>`);
    }
    // 07. Collaboration (exclude)
    if (USER_UNAUTH_COLLAB) {
      USER_UNAUTH_COLLAB.forEach(function (collaboration, index) {
        facetFilters.push(`named_tags.Collaboration:-${collaboration}`);
      });
    }

    switch (item.product_type) {
      case "RUGS":
        facetFilters.push(`meta.loloi.variant_option:${size}`);
        break;
      case "PILLOWS":
        facetFilters.push(`options.size:${size.substr(0, size.indexOf(" / "))}`);
        break;
      case "WALL ART":
        facetFilters.push(`options.size:${size.substr(0, size.indexOf(" / "))}`);
        break;
      case "POUFS":
        facetFilters.push(`options.size:${size.substr(0, size.indexOf(" / "))}`);
        break;
    }

    // Initialize search client
    if(opts.searchIndex) {
        const searchClient = algoliasearch(
            opts.id,
            opts.key
        );
        opts.mySearch = searchClient.initIndex(opts.searchIndex);
    }

    function renderCallback () {
      custom.typeDesignId.init();
      custom.lazyImages.init();
      custom.gtmHandler.init();
      custom.productCardPillow.init();
    }

    /**
     * getSimilarProducts
     * @params options - An options object
     *
     * Call algolia search API, returns Promise object
     */
    const getAlternativeProducts = () => {
      if(!opts.searchIndex) return;

      return opts.mySearch.search({
        hitsPerPage: opts.searchLimit,
        distinct: true,
        attributesToRetrieve: opts.attributesToRetrieve,
        filters: filters,
        facetFilters: facetFilters,
        numericFilters: numericFilters,
        optionalFilters: optionalFilters,
        sumOrFiltersScores: true
      });
    };

    /**
     * renderAlternativeProducts
     * @params hits - algolia results object
     *
     * Render each result after object manipuration,
     * Hide if no result from Algolia.
     */
    const renderAlternativeProducts = hits => {
      if (hits.length > 0) {

        // Variables
        let outputArray = [];
        let variantsPromises = [];
        var hitsLength = hits.length;
        while (hitsLength > 0) { outputArray.push(""); hitsLength--; };

        // Empty Container First
        document.getElementById(opts.resultsContainerID).innerHTML = "";

        //matches found append content to section container
        hits.forEach((hit, index) => {

          hit = custom.algoliaUtils.resultObjectReducer(hit);
          if (hit.named_tags && hit.named_tags.Collaboration & MANUAL_HIDE_COLLAB.indexOf(hit.named_tags.Collaboration) >= 0) return;
          if (hit.named_tags && hit.named_tags.Collaboration) hit.hideCollaboration = (HIDE_COLLAB.indexOf(hit.named_tags.Collaboration) >= 0);

          /**
           * NOTE: NEEDS REFACTOR HERE since similar logic is in algolia-search.js 
           */
          if (hit.product_type === 'PILLOWS' || hit.product_type === 'WALL ART' || hit.product_type === 'POUFS') {
            const variantFetch = custom.shopifyApi.getShopifyProductJson(hit.handle);
            variantsPromises.push(variantFetch);
            variantFetch.then(data => {
              if (!data) {
                outputArray[index] += opts.passDataToTemplate(hit);
              } else {
                const sizes = hit.product_type === 'PILLOWS' ? custom.algoliaUtils.getPillowSizeObject(data) : custom.algoliaUtils.getArtSizeObject(data);
                hit = Object.assign({}, hit, { 'sizes': sizes });
                outputArray[index] += (sizes) ? window.pillowCardTemplate.render(hit) : opts.passDataToTemplate(hit);
              }
            });
          } else {
            outputArray[index] += window.productCardTemplate.render(hit);
          }
        });

        if (variantsPromises.length > 0) {
          Promise.all(variantsPromises).then(data => {
            document.getElementById(opts.resultsContainerID).insertAdjacentHTML('beforeend', outputArray.join(""));
            renderCallback();
          });
        } else {
          document.getElementById(opts.resultsContainerID).insertAdjacentHTML('beforeend', outputArray.join(""));
          renderCallback();
        }

        //show the section
        document.getElementsByClassName(opts.resultsWrapperClass)[0].classList.remove("hidden");
        //hide the similar products section
        document.getElementsByClassName('js-similar-products')[0].classList.add("hidden");
        $(`.${opts.resultsWrapperClass}-link`).addClass('active');

      } else {
        //no matches found hide this section
        document.getElementsByClassName(opts.resultsWrapperClass)[0].classList.add("hidden");
        $(`.${opts.resultsWrapperClass}-link`).removeClass('active');
      }
    };

    getAlternativeProducts().then(res => {
      renderAlternativeProducts(res.hits);
    });
  }

  return {
    search
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/alternative-products.js